import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    "ShippingRequestOrigin", "OrderSelect", "PurchaseOrderSelect", "SupplierSelect",
    "PurchaseOrderId",
    "OriginZipcode", "OriginBusinessTypeBusiness", "OriginBusinessTypeFarm", "OriginLoadingOptionLoadingDock", "OriginLoadingOptionForklift", "OriginLoadingOptionLiftgate", "OriginLoadingOptionLoadingDockInput", "OriginLoadingOptionForkliftInput",
    "DestinationZipcode", "DestinationBusinessTypeFarm", "DestinationBusinessTypeBusiness", "DestinationLoadingOptionLoadingDock", "DestinationLoadingOptionForklift", "DestinationLoadingOptionLiftgate",
    "DestinationLoadingOptionLoadingDockInput", "DestinationLoadingOptionForkliftInput",
    "InsuredValue", "Weight", "NumberOfUnits", "OrderTypeCCE", "OrderTypeH85", "OrderId"
  ]

  connect() {
    this.element[this.identifier] = this
    window.addEventListener("click", this.onBgClick.bind(this))

    this.handleLoadingOptionChanges()
  }

  handleLoadingOptionChanges() {
    this.OriginLoadingOptionLoadingDockTarget.addEventListener("change", this.onOriginLoadingOptionChange.bind(this))
    this.OriginLoadingOptionForkliftTarget.addEventListener("change", this.onOriginLoadingOptionChange.bind(this))
    this.OriginLoadingOptionLiftgateTarget.addEventListener("change", this.onOriginLoadingOptionChange.bind(this))
    this.DestinationLoadingOptionLoadingDockTarget.addEventListener("change", this.onDestinationLoadingOptionChange.bind(this))
    this.DestinationLoadingOptionForkliftTarget.addEventListener("change", this.onDestinationLoadingOptionChange.bind(this))
    this.DestinationLoadingOptionLiftgateTarget.addEventListener("change", this.onDestinationLoadingOptionChange.bind(this))
  }

  onOriginLoadingOptionChange() {
    const radioValue = document.querySelector('input[name="shipping_request[origin_loading_option]"]:checked').value
    const loadingDockInput = this.OriginLoadingOptionLoadingDockInputTarget
    const forkliftInput = this.OriginLoadingOptionForkliftInputTarget

    if (radioValue == "loading_dock") {
      loadingDockInput.value = "true"
      forkliftInput.value = "false"
    } else if (radioValue == "forklift") {
      loadingDockInput.value = "false"
      forkliftInput.value = "true"
    } else if (radioValue == "liftgate") {
      loadingDockInput.value = "false"
      forkliftInput.value = "false"
    }
  }

  onDestinationLoadingOptionChange() {
    const radioValue = document.querySelector('input[name="shipping_request[destination_loading_option]"]:checked').value
    const loadingDockInput = this.DestinationLoadingOptionLoadingDockInputTarget
    const forkliftInput = this.DestinationLoadingOptionForkliftInputTarget

    if (radioValue == "loading_dock") {
      loadingDockInput.value = "true"
      forkliftInput.value = "false"
    } else if (radioValue == "forklift") {
      loadingDockInput.value = "false"
      forkliftInput.value = "true"
    } else if (radioValue == "liftgate") {
      loadingDockInput.value = "false"
      forkliftInput.value = "false"
    }
  }

  onBgClick(e) {
    const elems = document.querySelectorAll('[data-controller="form-resource-search"]')
    elems.forEach((elem) => {
      const controllerElem = this.application.getControllerForElementAndIdentifier(elem, "form-resource-search")
      controllerElem.hideResults()
    })
  }

  onFillData(data, resourceType) {
    console.log('onFillData', data, resourceType)
    if (resourceType == "order") {
      this.onFillOrderData(data)
    } else if (resourceType == "supplier") {
      this.onFillSupplierData(data)
    } else if (resourceType == "purchase_order") {
      this.onFillPurchaseOrderData(data)
    }

    this.onOriginLoadingOptionChange()
    this.onDestinationLoadingOptionChange()
  }

  onFillOrderData(order) {
    this.OrderIdTarget.value = order.id

    this.fillOriginDataFromOrder(order)
    this.fillDestinationDataFromOrder(order)

    if (order.insured_value !== "") {
      this.InsuredValueTarget.value = order.insured_value
    }
    if (order.weight !== "") {
      this.WeightTarget.value = order.weight
    }
    if (order.number_of_units !== "") {
      this.NumberOfUnitsTarget.value = order.number_of_units
    }
    if (order.is_hybrid85) {
      this.OrderTypeH85Target.checked = true
    } else {
      this.OrderTypeCCETarget.checked = true
    }
  }

  fillOriginDataFromOrder(order) {
    if (order.shipping_request_origin != "" && order.shipping_request_origin != null) {
      this.onFillSupplierData(order.shipping_request_origin)
      this.SupplierSelectTarget.value = order.shipping_request_origin.name
    } else {
      this.OriginZipcodeTarget.value = order.origin_zipcode

      if (order.origin_business_type == "business") {
        this.OriginBusinessTypeBusinessTarget.checked = true
      } else if (order.origin_business_type == "farm") {
        this.OriginBusinessTypeFarmTarget.checked = true
      } else {
        this.OriginBusinessTypeBusinessTarget.checked = true
      }

      if (order.origin_loading_option !== "") {
        if (order.origin_loading_option == "loading_dock") {
          this.OriginLoadingOptionLoadingDockTarget.checked = true
        } else if (order.origin_loading_option == "forklift") {
          this.OriginLoadingOptionForkliftTarget.checked = true
        } else if (order.origin_loading_option == "liftgate") {
          this.OriginLoadingOptionLiftgateTarget.checked = true
        }
      }

      if (order.origin_loading_option_loading_dock !== "") {
        this.OriginLoadingOptionLoadingDockTarget.checked = true
      }
      if (order.origin_loading_option_forklift !== "") {
        this.OriginLoadingOptionForkliftTarget.checked = true
      }
    }
  }

  fillDestinationDataFromOrder(order) {
    this.DestinationZipcodeTarget.value = order.destination_zipcode

    if (order.destination_business_type == "business") {
      this.DestinationBusinessTypeBusinessTarget.checked = true
    } else {
      this.DestinationBusinessTypeFarmTarget.checked = true
    }
    if (order.destination_loading_option !== "") {
      if (order.destination_loading_option == "loading_dock") {
        this.DestinationLoadingOptionLoadingDockTarget.checked = true
      } else if (order.destination_loading_option == "forklift") {
        this.DestinationLoadingOptionForkliftTarget.checked = true
      } else if (order.destination_loading_option == "liftgate") {
        this.DestinationLoadingOptionLiftgateTarget.checked = true
      }
    }
    if (order.destination_loading_option_loading_dock !== "") {
      this.DestinationLoadingOptionLoadingDockTarget.checked = true
    }
    if (order.destination_loading_option_forklift !== "") {
      this.DestinationLoadingOptionForkliftTarget.checked = true
    }
  }

  onFillPurchaseOrderData(purchase_order) {
    this.PurchaseOrderIdTarget.value = purchase_order.id

    if (purchase_order.order) {
      this.onFillOrderData(purchase_order.order)
    }
  }

  onFillSupplierData(supplier) {
    this.OriginZipcodeTarget.value = supplier.zipcode

    if (supplier.business_type == "business") {
      this.OriginBusinessTypeBusinessTarget.checked = true
    } else {
      this.OriginBusinessTypeFarmTarget.checked = true
    }

    if (supplier.loading_option !== "") {
      if (supplier.loading_option == "loading_dock") {
        this.OriginLoadingOptionLoadingDockTarget.checked = true
      } else if (supplier.loading_option == "forklift") {
        this.OriginLoadingOptionForkliftTarget.checked = true
      } else if (supplier.loading_option == "liftgate") {
        this.OriginLoadingOptionLiftgateTarget.checked = true
      }
    }

    if (supplier.loading_option_loading_dock !== "" && supplier.loading_option_loading_dock == true) {
      this.OriginLoadingOptionLoadingDockTarget.checked = true
    }
    if (supplier.loading_option_forklift !== "" && supplier.loading_option_forklift == true) {
      this.OriginLoadingOptionForkliftTarget.checked = true
    }
  }
}